import { ref } from "vue";
import caValidationService from "../services/caValidationService";

export function useCaValidation() {
  const isModalOpen = ref(false);
  const currentCaNumber = ref("");
  const currentCaId = ref(null);

  /**
   * Abre o modal de validação para um CA específico
   * @param {string} caNumber - Número do CA a ser validado
   * @param {number|string} caId - ID do CA no sistema (opcional)
   */
  const openValidationModal = (caNumber, caId = null) => {
    if (!caNumber) {
      console.error("Número do CA é obrigatório");
      return;
    }

    currentCaNumber.value = caNumber;
    currentCaId.value = caId;
    isModalOpen.value = true;
  };

  /**
   * Fecha o modal de validação
   */
  const closeValidationModal = () => {
    isModalOpen.value = false;
    currentCaNumber.value = "";
    currentCaId.value = null;
  };

  /**
   * Valida um CA sem abrir o modal (uso programático)
   * @param {string} caNumber - Número do CA a ser validado
   * @returns {Promise<Object>} - Resultado da validação
   */
  const validateCa = async (caNumber) => {
    return await caValidationService.validateCa(caNumber);
  };

  /**
   * Atualiza a validade de um CA no sistema
   * @param {number|string} caId - ID do CA no sistema
   * @param {Object} validationData - Dados de validação
   * @returns {Promise<Object>} - Resultado da atualização
   */
  const updateCaValidity = async (caId, validationData) => {
    return await caValidationService.updateCaValidity(caId, validationData);
  };

  /**
   * Callback executado quando o CA é atualizado com sucesso
   * @param {Object} updatedCa - Dados do CA atualizado
   */
  const onCaUpdated = (updatedCa) => {
    // Aqui você pode implementar lógica adicional após atualização
    console.log("CA atualizado:", updatedCa);
  };

  return {
    // Estados
    isModalOpen,
    currentCaNumber,
    currentCaId,

    // Métodos
    openValidationModal,
    closeValidationModal,
    validateCa,
    updateCaValidity,
    onCaUpdated,
  };
}
